/*
 *   File : confirm.js
 *   Author : https://evoqins.com
 *   Description : COnfirm modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect } from 'react';

//Custom components
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';


const AcceptModal = (props) => {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("accept-modal-close");
        button.click();
        props.handleClose();
    };

    // handle confirm 
    const _handleConfirm = () => {
        props.handleConfirm();
        _handleCloseModal();
    };

    return (
        <div className="modal fade"
            id="accept-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="AcceptModalLabel"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28 `}>
                <span id='accept-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">

                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-3">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            Confirm Bank Verification
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pt-0 pb-1 padding-32px-lr'>
                        <p className='mb-0 e-text-dark-gray e-primary-font e-font-16 e-font-weight-400 line-height-20px'>
                            Are you sure you want to approve the bank verification for:
                            Customer name: <span className='e-font-weight-600 '>{props.data.name}</span>  <br />
                            A/C No: <span className='e-font-weight-600'>{props.data.account_number}</span>
                        </p>

                    </div>

                    {/* Modal footer */}
                    <div className='modal-footer border-0 pt-4 padding-32px-lr padding-32px-bottom gap-4'>
                        <>
                            <SecondaryButton name="Cancel"
                                paddingBlock="py-3 padding-54px-lr"
                                onClick={_handleCloseModal} />
                            <PrimaryButton name="Confirm"
                                paddingBlock="padding-64px-lr py-3"
                                onClick={_handleConfirm} />
                        </>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default AcceptModal;
